import { useFaqsQuery } from '@data/faqs/useFaqsQuery';

export type FaqProps = {
  title: string;
  config: {
    items: string[];
  };
};

export function Faq(props: FaqProps) {
  const faqRes = useFaqsQuery({ ids: props.config.items.join(',') });
  const properOrder = props.config.items;
  const faqList = (faqRes?.data?.items ?? []).sort((a, b) => {
    const aIndex = properOrder.indexOf(a.id);
    const bIndex = properOrder.indexOf(b.id);

    return aIndex - bIndex;
  });

  if (faqList.length === 0) {
    return null;
  }

  return (
    <div className="faq-container">
      {props.title && <h2 className="faq-title">{props.title}</h2>}
      <div className="faq-items">
        {faqList.map(({ id, title, content }) => (
          <details key={id}>
            <summary>{title}</summary>
            <div className="article-details__content">
              <div dangerouslySetInnerHTML={{ __html: content }} />
            </div>
          </details>
        ))}
      </div>
    </div>
  );
}
